import type { ReactNode } from 'react';

import { classNames } from '@/utils/classNames';

import styles from '@/styles/layout.module.css';

type PageContainerProps = {
  children: ReactNode;
  className?: string;
};

export function PageContainer({ children, className }: PageContainerProps): JSX.Element {
  return <div className={classNames(styles.pageContainer, className)}>{children}</div>;
}
